import React from 'react';
import { Redirect, Route, matchPath, RouteComponentProps, Switch } from 'react-router-dom';
import Tabs from 'shared/components/Tabs';
import { PageNotFound } from 'shared/components';
import Cod from './Routes/Cod';
import PaymentCod from './Routes/PaymentCod';

type Tabs = 'cod-in' | 'cod-out';

const CashOnDeliveryByShipment: React.FC<RouteComponentProps> = (props) => {
  const { history, match, location } = props;

  const selectTab = (tabIndex: Tabs) => {
    const getUrl = match.path;
    history.push(`${getUrl}/${tabIndex}`);
  };

  const checkTabsActive = (tabIndex: Tabs) => {
    return !!matchPath(location.pathname, `${match.path}/${tabIndex}`);
  };

  const tabs = [
    {
      name: 'COD-IN',
      icon: 'file',
      active: checkTabsActive('cod-in'),
      clicked: () => selectTab('cod-in'),
    },
    {
      name: 'COD-OUT',
      icon: 'file',
      active: checkTabsActive('cod-out'),
      clicked: () => selectTab('cod-out'),
    },
  ];

  return (
    <>
      <Tabs menu={tabs} />
      <Switch>
        {match.isExact && <Redirect to={`${match.path}/cod-in`} />}
        <Route path={`${match.path}/cod-in`} component={Cod} />
        <Route path={`${match.path}/cod-out`} component={PaymentCod} />
        <Route component={PageNotFound} />
      </Switch>
    </>
  );
};

export default CashOnDeliveryByShipment;
